<section>
  <h2>Manage Evidence Storage Locations</h2>
  <div class="content-wrapper">
    <app-evidence-storage-location></app-evidence-storage-location>
  </div>
</section>
